module.exports = __webpack_public_path__ + "img/img_qrcode_none.89fa4d53.gif";